import { throttle, loadLibrary } from "./Util";
import { LIB_URL } from './App';
import {loadCaptchaScript} from './Form.js';

$(function () {
    if ($("#col-errand, #col-errand-popup, #contacts-request, #cityes").length) {
        loadLibrary(LIB_URL.SELECT2, () => {
            $("#col-errand").select2({
                placeholder: "",
                minimumResultsForSearch: -1,
                dropdownCssClass: "select-dropdown",
                dropdownParent: $(".select-wrap-form"),
                language: "ru",
            });

            $("#col-errand-popup").select2({
                placeholder: "",
                minimumResultsForSearch: -1,
                dropdownCssClass: "select-dropdown",
                dropdownParent: $(".select-wrap-form-popup"),
                language: "ru",
            });

            $("#contacts-request").select2({
                placeholder: "",
                minimumResultsForSearch: -1,
                dropdownCssClass: "select-dropdown",
                dropdownParent: $(".select-wrap-form-contacts"),
                language: "ru",
            });

            $("#cityes").select2({
                placeholder: "",
                minimumResultsForSearch: -1,
                dropdownCssClass: "select-dropdown",
                dropdownParent: $(".select-wrap-cities"),
                language: "ru",
            });
        });
    }

    // скролл к верху стрницы
    let $anchor = $(".js-anchor-up");
    let scrollTopToShowAnchor = $anchor.attr("data-scroll-top");

    App.W.on("scroll", throttle(showAnchor, 100));

    function showAnchor() {
        let scrollTop = App.W.scrollTop();

        if (scrollTop > scrollTopToShowAnchor) {
            $anchor.addClass("anchor-up--active");
        } else {
            $anchor.removeClass("anchor-up--active");
        }
    }

    $anchor.click(function () {
        $("html, body").animate({ scrollTop: 0 }, 700);
    });

    $(".js-btn-repeat-send").click(function (e) {
        e.preventDefault();
        $(this).closest(".js-form-success-message").removeClass("_active");
        $(this).closest(".js-trial-form-wrapper").removeClass("success-form");
    });

    $("#phone, #phone-popup").on("input", function () {
        const val = $(this)
            .val()
            .replace(/[^0-9\s()+-]/g, "");
        $(this).val(val);
    });

    $(".js-copy-link").click(function (e) {
        e.preventDefault();
        $(this).addClass("copied");
        let $tmp = $("<input>");
        App.B.append($tmp);
        $tmp.val($(this).attr("href")).select();
        document.execCommand("copy");
        $tmp.remove();
    });

    let $btnPopupOpen = $(".js-btn-popup-open");
    let $btnPopupMiceOpen = $(".js-btn-popup-mice-open");

    let $popup = $(".js-popup");
    let $popupMice = $(".js-popup-mice");

    let $btnClosePopup = $(".js-btn-close-popup");
    let $btnClosePopupMice = $(".js-btn-close-popup-mice");


    $btnPopupOpen.click(function (e) {
        e.preventDefault();
        App.H.addClass("_overlay");
        $popup.addClass("_active");

        if ($(e.target).attr('data-redirect-to-hubspot')) {
            const redirectToHubspotLink = $(e.target).attr('data-redirect-to-hubspot');

            $popup.find('form').attr('data-redirect-to-hubspot', redirectToHubspotLink);
            $popup.find('form').append(
                `<input type="hidden" name="hubspotRedirectLink" value="${redirectToHubspotLink}" />`
            );
        }
    });

    $('.js-form').each(function() {
        loadCaptchaScript($(this));
    });

    $btnPopupMiceOpen.click(function (e) {
        e.preventDefault();
        App.H.addClass("_overlay");
        $popupMice.addClass("_active");
    });

    $btnClosePopup.click(function (e) {
        e.preventDefault();
        App.H.removeClass("_overlay");
        $popup.removeClass("_active");
        $popup.find('form').removeAttr('data-redirect-to-hubspot');
        $popup.find('form').find(`input[name="hubspotRedirectLink"]`).remove();

        if (
            App.W.width() < 768 &&
            $(this)
                .closest(".js-popup")
                .find(".js-trial-form-wrapper")
                .hasClass("success-form")
        ) {
            $(this)
                .closest(".js-popup")
                .find(".js-form-success-message")
                .removeClass("_active");
            $(this)
                .closest(".js-popup")
                .find(".js-trial-form-wrapper")
                .removeClass("success-form");
        }
    });

    $btnClosePopupMice.click(function (e) {
        e.preventDefault();
        App.H.removeClass("_overlay");
        $popupMice.removeClass("_active");

        if (
            App.W.width() < 768 &&
            $(this)
                .closest(".js-popup-mice")
                .find(".js-trial-form-wrapper")
                .hasClass("success-form")
        ) {
            $(this)
                .closest(".js-popup-mice")
                .find(".js-form-success-message")
                .removeClass("_active");
            $(this)
                .closest(".js-popup-mice")
                .find(".js-trial-form-wrapper")
                .removeClass("success-form");
        }
    });

    $(".checkbox-item").click(function () {
        $(".checkbox-item").removeClass("_active");
        $(this).addClass("_active");
    });

    let itiArr = [];
    let prevPlaceholderArr = [];

    function setMask($input) {
        let currIndex = $input.attr("data-intl-tel-input-id");
        let iti = itiArr[currIndex];
        let prevPlaceholder = prevPlaceholderArr[currIndex];
        let dialCode = iti.getSelectedCountryData().dialCode;
        let placeholder = $input.attr("placeholder");
        let $label = $input.closest(".js-input-wrap").find("[data-label]");

        if (placeholder != prevPlaceholder) {
            prevPlaceholderArr[currIndex] = placeholder = placeholder
                .replace(dialCode, "&")
                .replace(/[0-9]/g, "9")
                .replace("&", dialCode.replace(/9/g, "\\9"));
            $input.val("");
            $input.inputmask("placeholder", {
                showMaskOnHover: false,
                mask: placeholder,
                placeholder: "_",
                onKeyValidation: function () {
                    if ($input.inputmask("isComplete")) {
                        $input.removeClass("_error");
                    }

                    if (
                        (!$input.is("[data-required]") ||
                            $input.is("._filled")) &&
                        $input.val() === ""
                    ) {
                        $input.removeClass("_error");
                        $label.text("");
                    }
                },
                oncomplete: function () {
                    // если маска верная
                    $input.addClass("_mask-valid");
                    $input
                        .removeClass("_error, _notvalidated")
                        .addClass("_filled")
                        .parent()
                        .removeClass("_error");
                    $label.text("");
                },
                onincomplete: function () {
                    // если маска заполнена не полностью
                    $input.removeClass("_mask-valid");

                    if (
                        ($input.is("[data-required]") &&
                            !$input.is("._filled")) ||
                        $input.val() !== ""
                    ) {
                        $input
                            .addClass("_error")
                            .removeClass("_filled")
                            .parent()
                            .addClass("_error");
                        $label.text(
                            $label.text().length > 0
                                ? $label.text()
                                : window.validateMessages.required
                        );
                    }

                    if ($input.val() === "") {
                        $input.removeClass("_error");
                        $label.text("");
                    }
                },
            });

            $input.closest(".js-input-wrap").addClass("_filled");
        }

        setTimeout(function () {
            // проверяем, если поле телефона уже заполнено, то убираем классы валидации и ставим класс, что поле заполнено
            if ($input.inputmask("isComplete")) {
                $input.removeClass("_error, _notvalidated").addClass("_filled");
            }
        });
    }

    function renderMaskPhone() {
        // Вариант номера разных стран
        $(".js-phone-mask").each(function (i, input) {
            loadLibrary([
                LIB_URL.JQ_INTLTELINPUT,
                LIB_URL.JQ_INPUTMASK
            ], () => {
                let $input = $(this);
                let searchPlaceholder = $input.data('search-placeholder');
                let value = $input.val();
                let countries = $input.attr("data-country-list");
                let countryListArray = JSON.parse(countries);

                if (countryListArray.length === 1) {
                    $input.closest(".js-input-wrap").addClass("_one-country");
                } else {
                    $input.closest(".js-input-wrap").removeClass("_one-country");
                }

                $input.attr("data-intl-tel-input-id", i);
                intlTelInput(input, {
                    onlyCountries: countryListArray,
                    initialCountry: $input.data("country-start"),
                    nationalMode: false,
                    autoPlaceholder: "aggressive",
                    utilsScript: "/js/utils.js",
                    i18n: {
                        searchPlaceholder: searchPlaceholder || "Введите имя или код страны",
                    }
                });

                let iti = window.intlTelInputGlobals.getInstance(this);
                let prevPlaceholder = $input.attr("placeholder");

                prevPlaceholderArr.push(prevPlaceholder);

                iti.promise.then(function () {
                    setMask($input);
                    iti.setNumber(value);
                });

                itiArr.push(iti);

                $input[0].addEventListener("countrychange", function () {
                    setMask($input);
                });

                $input[0].addEventListener("open:countrydropdown", function () {
                    $("html").addClass("_countrydropdown");
                });

                $input[0].addEventListener("close:countrydropdown", function () {
                    $("html").removeClass("_countrydropdown");
                });

                $input.attr("autocomplete", "tel");
            });
        });
    }

    renderMaskPhone();
});

$(document).ready(function () {
    function onConversationsAPIReady() {
        console.log(`HubSpot Conversations API: ${window.HubSpotConversations}`);
    }
    /*
     If external API methods are already available, use them.
    */
    if (window.HubSpotConversations) {
        onConversationsAPIReady();
        window.HubSpotConversations.on('conversationStarted', (payload) => {
            console.log('жамк в форме');
            $.ajax({
                url: '/hubspot-form',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    conversationId: payload.conversationId,
                    url: window.location.href
                }),
                success: function(response) {
                    console.log('Запрос успешно отправлен:', response);
                },
                error: function(xhr, status, error) {
                    console.error('Ошибка запроса:', error);
                }
            });
        });
    } else {
        /*
          Otherwise, callbacks can be added to the hsConversationsOnReady on the window object.
          These callbacks will be called once the external API has been initialized.
        */
        window.hsConversationsOnReady = [onConversationsAPIReady];
    }
});


